import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import ZendeskRightPanel from "../../zendesk/zendesk-right-panel";

export interface IZendeskPropertiesState {}

export interface IZendeskPropertiesProps {}

class ZendeskProperties extends PureSdComponent<
  IZendeskPropertiesProps & IWithSDProps & IWithContextProp,
  IZendeskPropertiesState
> {
  constructor(props: IZendeskPropertiesProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <ZendeskRightPanel />
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason === ESdChangeReason.UpdateAuth) {
      return true;
    }
    return false;
  };
}

const zendeskProperties = withContext<IZendeskPropertiesProps>(withSD<IZendeskPropertiesProps>(ZendeskProperties));
export { zendeskProperties as ZendeskProperties };
